<template>
  <form-section :title="$t('Profiles_Overview_Title_RecentEvents')">
    <rest-list
      :payload="fetchEndpoint"
      :border="false"
      :outline="false"
      :filterable="false"
      :pagination="false"
    >
      <rest-list-column-date
        :sortable="false"
        :unix="!clickhouse"
        :prop="clickhouse ? 'timestamp' : 'create_time'"
        :title="$t('ProfilesEvents_Field_Timestamp')"
        :width="180"
      />

      <rest-list-column
        :prop="clickhouse ? 'event_name' : 'event_title'"
        :title="$t('ProfilesEvents_Field_Title')"
        :sortable="false"
      />
    </rest-list>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'RecentEvents',

  components: {
    FormSection,
    RestList,
    RestListColumn,
    RestListColumnDate
  },

  props: {
    profileId: {
      type: String,
      required: true
    }
  },

  computed: {
    clickhouse() {
      return this.$hasFeature('shouldReadEventsFromClickhouse')
    },

    fetchEndpoint() {
      if (this.clickhouse) {
        return projectEndpoint({
          method: 'get',
          url: `event-hits-clickhouse`,
          params: {
            fields: ['event_name', 'timestamp'],
            profile_id: this.$route.query.profile_id,
            sort: '-timestamp',
            'per-page': 3,
            page: 1
          }
        })
      } else {
        return projectEndpoint({
          method: 'get',
          url: `event-hits`,
          params: {
            expand: 'event_title',
            profile_id: this.$route.query.profile_id,
            sort: '-create_time',
            'per-page': 3,
            page: 1
          }
        })
      }
    }
  }
}
</script>

<style scoped>
>>> th {
  color: #acb0b5;
  font-size: 12px;
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/RecentEvents.vue